export default __webpack_public_path__ + "bdf1ad0582b937cc1b78cb7ec9f22d65.svg";